import { LoginRadiusWidget, LRWidgetType } from './base';

export class ResetPasswordWidget extends LoginRadiusWidget<any, any> {
    constructor(container: string, lrObject: any) {
        super(container);
        this.widgetType = LRWidgetType.RESET_PASSWORD;
        this.lrObject = lrObject;
    }
}
